"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeStore = void 0;

var _redux = require("redux");

var _reducer = require("./reducer");

var _fetchMiddleware = require("./fetch-middleware");

var makeStore = function makeStore() {
  var debug = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return (0, _redux.createStore)(_reducer.reducer, {
    config: {
      debug: debug
    },
    data: {
      loading: false,
      spot: {
        active: {}
      }
    },
    errors: []
  }, (0, _redux.applyMiddleware)(_fetchMiddleware.fetchMiddleware));
};

exports.makeStore = makeStore;